import z from "zod";
import { cbHttp } from "./http.service"
import { RequisitionsEntryResponse, RequisitionsSchema } from "@/schemas/requisitions.schema";

export const getRequisitionsEntries = async (): Promise<z.infer<typeof RequisitionsSchema>[]> => {
    return cbHttp.get("/api/requisition/requisitionsentries");
}

export const postCreateRequisitionEntry = async (data: FormData): Promise<z.infer<typeof RequisitionsEntryResponse>> => {
    return cbHttp.post("/api/requisition/createrequisitionentry", data);
}

export const deleteRequisitionEntry = async (data: FormData): Promise<boolean> => {
    return cbHttp.post("/api/requisition/deleterequisitionentry", data);
}

export const getRequisitionserverfolder = async(): Promise<Array<string>> => {
    return cbHttp.get("/api/requisition/requisitionserverfolder");
}